(function() {
var forum = require('./forum');
var dom = require('./dom'), doc=dom.doc, URL=dom.URL;
doc.id("menubug"    ).onclick = forum.genbug;
doc.id("menufeature").onclick = forum.genfeature;

var Login = require('./login');
var Alert = require('./alert'), new_text_alert=Alert.new_text_alert;
if (URL.param.login) Login.login_dialog();
if (URL.param.logout) { Login.logout(); new_text_alert("You have been logged out."); }
})() (function() {
var forum = require('./forum');
var dom = require('./dom'), doc=dom.doc, URL=dom.URL;
doc.id("menubug"    ).onclick = forum.genbug;
doc.id("menufeature").onclick = forum.genfeature;

var Login = require('./login');
var Alert = require('./alert'), new_text_alert=Alert.new_text_alert;
if (URL.param.login) Login.login_dialog();
if (URL.param.logout) { Login.logout(); new_text_alert("You have been logged out."); }
})() 